export default __webpack_public_path__ + "static/media/bibooLogo.b146d3a4.svg";